import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { InjectionToken } from "tsyringe";

import { createModalToken } from "@components/Modal/ModalManager";
import { LoggerInterface } from "@interfaces/LoggerInterface";

import { SAVE_WISHLIST_MODAL_ACTION_TYPES } from "./constants/constants";

export const wishlistApplicationLoggerToken = Symbol(
    "WishlistApplicationLoggerToken"
) as InjectionToken<LoggerInterface>;

export const wishlistAuthApiClientToken = Symbol(
    "wishlistAuthApiClientToken"
) as InjectionToken<ApiClientInterface>;

export const saveWishlistModalToken = createModalToken<{
    actionType: SAVE_WISHLIST_MODAL_ACTION_TYPES;
    productId?: number | null;
    variantId?: number | null;
}>("SaveWishlistModal");

export const wishlistsManageApproversModalToken = createModalToken<{
    wishlistId: number;
}>("WishlistsManageApproversModal");

export const saveForLaterModalToken = createModalToken<{
    productId?: number | null;
    variantId?: number | null;
}>("SaveForLaterModal");
